module.exports = __webpack_public_path__ + "media/ספר.dab974ea.mp3";